export default __webpack_public_path__ + "ae2c3810a2bc8eeb786d56575bc18d15.jpg";